export function setParamsOnBrowserHistory(params: object) {
    const currentUrl = new URL(window.location.href);

    Object
        .keys(params)
        .forEach(
            (param) => {
                currentUrl.searchParams.set(param, params[param]);
            }
        );

    window.history.replaceState({}, '', currentUrl.href);
}
